import { Box, Button } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { Link } from 'react-router';
import TabHeader from './TabHeader';

export default function PasswordManagement() {
  return (
    <Box>
      <TabHeader
        title="Password & Security"
        subtitle="Manage your password, email, and multi-factor authentication."
      />

      <Button
        component={Link}
        to="/settings"
        target="_blank"
        leftSection={<IconLock size={14} />}
        mt="md"
      >
        Manage Credentials
      </Button>
    </Box>
  );
}
